import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const StyledNextAptWrapper = styled('div')(
  ({ theme }) => `
    flex: 1 1 0%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-end;
    margin-top: ${theme.DS_spacing(['xs'])};
    
    p {
      width: 100%;
    }
  `,
);

export const StyledNextAppointmentTime = styled(Typography)(
  ({ theme }) => `
    width: fit-content;
    border-radius: 6px;
    margin-top: ${theme.DS_spacing(['xxs'])};
    padding: ${theme.DS_spacing(['xxxs'])} ${theme.DS_spacing(['xxs'])};
    background-color: ${theme.DS_palette.background.lightBlue};
    
    &.selected {
      background-color: ${theme.DS_palette.primary.white};
    }
  `,
);
